<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('subareas')"
      :columns="columns"
      :column_search="false"
      :extra_buttons="extra_buttons"
      :extra_data="{ area_uuid: area_uuid }"
      resource_url="/museum/subarea/datatables"
    ></generic-table>
    <subarea-modal ref="subarea_modal" @success="refresh" />
    <regions-modal ref="regions_modal" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import SubareaModal from "./subarea_modal/Index.vue";
import RegionsModal from "./regions_modal/Index.vue";

export default {
  name: "AreaDatatable",
  components: { GenericTable, SubareaModal, RegionsModal },
  data() {
    let v = this;
    return {
      area_uuid: "",
      api_host,
      extra_buttons: [
        {
          // text: v.$t("add"),
          tooltip: v.$t("add"),
          text: "",
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.subarea_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("regions"),
                icon: "fa fa-cubes",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  // console.log("regions", v.$refs.regions_modal);
                  // console.log("subarea", v.$refs.subarea_modal);
                  v.$refs.regions_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete subarea?"),
                    v,
                    () => {
                      del("/museum/subarea", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.subarea_modal.show_modal(v.area_uuid);
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    init(area_uuid) {
      let v = this;
      v.area_uuid = area_uuid;
      try {
        v.$refs.datatable.destroy();
      } catch (error) {
        error_message(error);
      }
      setTimeout(() => {
        v.refresh();
      }, 100);
    },
  },
  mounted() {},
};
</script>

<style></style>
